export default function($) {
  var speed = 90; // ms

  $('.js-nav-mobile-button').click(function () {
    $('.js-nav-items').slideToggle(speed);
    $(this).toggleClass('c-main-nav__mobile-button--active');

    // Mobile Nav height

    if( $(window).width() < 960 ) {
      if( $(this).hasClass('c-main-nav__mobile-button--active') ) {
        var header_height = $('header').outerHeight();
        var window_height = $(window).height();
        var menu_height = parseInt(window_height - header_height);
        $('.c-main-nav__items').css( 'max-height', menu_height );
      }
    }
  });

  $('.menu-item-has-children a').click(function () {
    if( $(this).parent('.menu-item-has-children').hasClass('menu-item-has-children--active') ) {
      $(this).parent('.menu-item-has-children').removeClass('menu-item-has-children--active');
    } else {
      $(this).parent('.menu-item-has-children').addClass('menu-item-has-children--active');
    }
    $(this).parent('.menu-item-has-children').siblings('.menu-item-has-children--active').each(function(i, sibling) {
      $(sibling).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
    });
    $(this).siblings('.sub-menu').slideToggle(speed);
  });

  $(document).click(function(event) {
    if (!$(event.target).closest('.js-nav').length) {
      if ($('.sub-menu').is(":visible")) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
      }
    }

    if ($('.js-mini-order-sumup').hasClass('open') && !$(event.target).closest('.js-mini-order-sumup').length) {
      $('.js-mini-order-sumup').removeClass('open');
      $('.js-nav-mobile-order-sumup').removeClass('c-nav-mobile-order-sumup--active');
    }
  });

  // Styleguide nav
  $('.sg-nav-mobile-button').click(function () {
    $('.js-sg-nav').slideToggle(speed);
  });

  // Mini order sumup nav
  $('.js-nav-mobile-order-sumup').click(function (event) {
    event.stopPropagation();
    $(this).toggleClass('c-nav-mobile-order-sumup--active');

    $('.js-mini-order-sumup').toggleClass('open');

    if( $(window).width() < 960 ) {
      if( $(this).hasClass('c-nav-mobile-order-sumup--active') ) {
        var header_height = $('header').outerHeight();
        var window_height = $(window).height();
        var mini_order_height = parseInt(window_height - header_height);
        $('.js-mini-order-sumup').css( {
          'max-height': mini_order_height,
          'overflow-y': 'scroll'
        });
      }
    }
  });

}
